import CheckboxTree, { CheckboxTreeNode, CheckboxTreeStore } from "designSystem/components/checkbox/CheckboxTree";
import React from "react";

export default () => {
	const store = new CheckboxTreeStore(undefined, () => console.log("Tree changing"), (node) => console.log("Node changing: ", node.uniqueId));

	const root = store.createNode("rootChild", "test name", true);

	const newChildA = store.createNode("a", "This is the first button.", true, root);

	const newChildB = store.createNode("b", "Another button.", true, root);

	const newChildC = store.createNode("c", "This is a button with extremely long text that will definitely need to wrap included as a test.  This is a button with extremely long text that will definitely need to wrap included as a test", true, root);

	const secondRoot = store.createNode("rootChild2", "test name2", true);

	const newChildD = store.createNode("d", "BAnother child", true, secondRoot);

	return (
		<CheckboxTree
			branchSpacing="6px"
			displayCounts
			store={store}
		/>
	);
};